export default {
      id: "attachment-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#attachment",
      toString: function () {
        return this.url;
      }
    }